import { useTranslation } from 'react-i18next';
import {Helmet} from "react-helmet";

function Error() {
	
	const { t } = useTranslation();
	
	return (
		<>
			<Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
			<div className="vh-100 my-auto overflow-auto">
				<div className="container d-flex flex-column h-100">
				   <div className="row justify-content-center align-items-center h-100">
					  <div className="mx-auto col-lg-10">
						 <div className="row justify-content-center align-items-center">
							<div className="col-md-2 px-4 px-lg-0 text-center">
								<i className="bi bi-rocket-takeoff-fill fs-10"></i>
							</div>
							<div className="col-md-8">
							   <div className=" mb-6 mb-lg-0 text-center py-4">
								  <h1 className="mt-4">{t("error500.title")}</h1>
								  <p className="mb-5">{t("error500.subtitle")}</p>
							   </div>
							</div>
						 </div>
					  </div>
				   </div>
				</div>
		  </div>
		</>
	);
}
export default Error;